import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useModules } from "@/lib/useModules";
import { AppTopBar } from "@/components/AppTopBar";

export default function OrderImport() {
  const { user } = useAuth();
  const { can: canModule, ready: modReady } = useModules();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const upload = async (e) => {
    e.preventDefault();
    if (!file) return;
    setError("");
    setResult(null);
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/orders/import-fast", fd);
      setResult(data);
    } catch (err) {
      console.error(err);
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (modReady && !canModule("ORDER_GINEE")) {
    return (
      <div className="app-shell">
        <AppTopBar active="orders" />
        <main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main>
      </div>
    );
  }

  const Stat = ({ label, value, tid }) => (
    <div className="stat-box"><span className="meta-label">{label}</span><span className="stat-value" data-testid={tid}>{value}</span></div>
  );

  return (
    <div className="app-shell">
      <AppTopBar active="orders" />
      <main className="content">
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}

        <section className="panel" data-testid="import-panel">
          <div className="panel-head">
            <h2 className="panel-title">Import Order Ginee</h2>
            <button className="btn-primary" onClick={() => navigate("/imports")} data-testid="goto-imports">Riwayat Import & Picking</button>
          </div>
          <p className="biz-sub" style={{ marginBottom: 16 }}>Upload file Excel export asli dari Ginee (.xlsx). Mapping berdasarkan nama header. Import memakai jalur set-based agar batch besar tidak membebani ERP dengan query per order/SKU.</p>
          <form onSubmit={upload}>
            <input type="file" accept=".xlsx,.xls" onChange={(e) => setFile(e.target.files[0])}
              className="field-input" data-testid="file-input" />
            <div className="form-actions">
              <button className="btn-primary" type="submit" disabled={loading || !file} data-testid="import-button">
                {loading ? "Memproses..." : "Jalankan Import"}
              </button>
            </div>
          </form>
        </section>

        {result && result.already_imported && (
          <section className="panel" data-testid="already-imported">
            <h2 className="panel-title">Sudah Pernah Di-import</h2>
            <p className="biz-sub" style={{ marginBottom: 16 }}>{result.message}</p>
            <div className="form-actions">
              <button className="btn-primary" onClick={() => navigate(result.batch_id ? `/imports/${result.batch_id}` : "/imports")} data-testid="open-existing-batch">Buka Import Batch & Picking</button>
            </div>
          </section>
        )}

        {result && !result.already_imported && (
          <section className="panel" data-testid="import-result">
            <h2 className="panel-title">Hasil Import</h2>
            <div className="stat-grid">
              <Stat label="Total Row" value={result.total_rows} tid="res-total-rows" />
              <Stat label="Unique Order" value={result.total_orders} tid="res-total-orders" />
              <Stat label="Inserted" value={result.inserted_orders} tid="res-inserted" />
              <Stat label="Updated" value={result.updated_orders} tid="res-updated" />
              <Stat label="Rejected Row" value={result.rejected_rows} tid="res-rejected" />
              <Stat label="Unknown SKU" value={result.unknown_sku_count} tid="res-unknown-sku" />
              <Stat label="Unresolved Store" value={result.unresolved_store_count} tid="res-unresolved-store" />
            </div>
            {result.performance_path && <div className="alert-info" style={{ marginTop: 12 }}>Performance path: {result.performance_path}</div>}
            {result.error_summary && (result.error_summary.unknown_skus?.length > 0 || result.error_summary.unresolved_stores?.length > 0 || result.error_summary.rejected_rows?.length > 0) && (
              <div className="exception-box" data-testid="exception-box">
                {result.error_summary.unknown_skus?.length > 0 && <div>SKU tidak dikenal: {result.error_summary.unknown_skus.join(", ")}</div>}
                {result.error_summary.unresolved_stores?.length > 0 && <div>Toko tidak dikenal: {result.error_summary.unresolved_stores.join(", ")}</div>}
                {result.error_summary.rejected_rows?.length > 0 && <div>Row ditolak: {result.error_summary.rejected_rows.length}</div>}
              </div>
            )}
            <div className="form-actions">
              <button className="btn-ghost" onClick={() => navigate("/orders/list")} data-testid="goto-orders">Lihat Daftar Order</button>
            </div>
          </section>
        )}
      </main>
    </div>
  );
}
